
import React from 'react'
import Page from '../components/Page';

export default class extends React.Component {
  render() {
    return (
      <Page title="Repairs and Recharges" padding>
        <p>1 Ort Rune + Weapon --> Fully Repaired Weapon</p>
        <p>1 Ral Rune + Armor --> Fully Repaired Armor</p>
        <p>1 Ort Rune + 1 Chipped Gem (any kind) + Weapon --> Fully Repaired and Recharged Weapon</p>
        <p>1 Ral Rune + 1 Flawed Gem (any kind) + Armor --> Fully Repaired and Recharged Armor</p>
      </Page>
    );
  }
}